import { render } from "./ToastPage.vue?vue&type=template&id=1a4aa795&scoped=true"
import script from "./ToastPage.vue?vue&type=script&lang=js"
export * from "./ToastPage.vue?vue&type=script&lang=js"

import "./ToastPage.vue?vue&type=style&index=0&id=1a4aa795&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4aa795"]])

export default __exports__